import classNames from 'classnames';
import PropTypes, { func, object } from 'prop-types';
import React from 'react';

import css from './IconClose2.module.css';

const IconClose2 = props => {
  const { className, rootClassName, style, onClick } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      onClick={onClick}
      style={style}
      className={classes}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M2.20117 3.14465L3.14396 2.20183L13.7979 12.8554L12.8551 13.7982L2.20117 3.14465Z" />
      <path d="M2.20117 12.8556L12.8547 2.20166L13.7976 3.14446L3.144 13.7984L2.20117 12.8556Z" />
    </svg>
  );
};

const { string } = PropTypes;

IconClose2.defaultProps = {
  className: null,
  rootClassName: null,
  onClick: () => {},
  style: {},
};

IconClose2.propTypes = {
  className: string,
  rootClassName: string,
  onClick: func,
  style: object,
};

export default IconClose2;
